'use strict';

define('composer/divider', ['quill'], (Quill) => {
	var BlockEmbed = Quill.import('blots/block/embed');

	class Divider extends BlockEmbed {
		static create() {
			const node = super.create();
			node.innerHTML = '<br>';
			return node;
		}
	}

	Divider.blotName = 'Divider';
	Divider.className = 'divider';
	Divider.tagName = 'p';

	return Divider;
});
